import { HttpInterceptorFn, HttpEvent } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { catchError, throwError, switchMap, Observable } from 'rxjs';
import { from } from 'rxjs';

/**
 * Interceptor HTTP para manejar la autenticación automática
 * - Maneja errores 401 intentando renovar el token
 * - Reintenta la petición original después de renovar
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);

  // Clonar la petición para agregar credentials: 'include'
  const authReq = req.clone({
    withCredentials: true,
  });

  return next(authReq).pipe(
    catchError((error) => {
      // Si recibimos un 401, intentar renovar el token
      if (error.status === 401) {
        return from(authService.refreshToken()).pipe(
          switchMap(() => {
            // Token renovado, reintentar la petición original
            const retryReq = req.clone({
              withCredentials: true,
            });
            return next(retryReq);
          }),
          catchError((refreshError) => {
            // No se pudo renovar el token, propagar el error
            return throwError(() => refreshError);
          })
        );
      }

      // Para otros errores, solo propagarlos
      return throwError(() => error);
    })
  );
};
